import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo, useState, useCallback } from 'react';
import { useParams, useMatch } from 'react-router-dom';
import { propShape, propOneOf, propStr, propFunc, propNumber, } from '../../../../helpers/custom-prop-types';
import { useArrayWithIndex } from '../../../../helpers/use/useArray';
import SlideSearchShareStatusTabContent from './Parts/SlideSearchShareStatusTabContent';
import SlideSearchShareStatusTabHeader from './Parts/SlideSearchShareStatusTabHeader';
/**
 * 共有状況をタブで表示
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareStatusTab = (props) => {
    const { className, initialCurrentTab, onClickItem, receive, share, skeletons: rawSkeletons, } = props;
    const [currentTab, changeCurrentTab] = useState(initialCurrentTab);
    const { id: paramId } = useParams();
    const isReceiveFolderOnePage = !!useMatch('/proffit_search/receive_folder/:id');
    const isShareHistoryOnePage = !!useMatch('/proffit_search/share_history/:id');
    const skeletons = useArrayWithIndex(rawSkeletons);
    /**
     * タブに表示する内容
     * @type {[{count, text: string, value: string}, {count, text: string, value: string}]}
     */
    const tabs = useMemo(() => [
        {
            count: receive.unreadCount,
            text: 'スライド受領',
            value: 'receive',
        },
        {
            count: share.unreadCount,
            text: 'スライド共有',
            value: 'share',
        },
    ], [receive.unreadCount, share.unreadCount]);
    /**
     * タブのクリック時のイベント
     * @type {(function(*): void)|*}
     */
    const onClickTab = useCallback((e) => {
        const { value } = e.currentTarget;
        changeCurrentTab(value);
    }, [changeCurrentTab]);
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_share_status_tab', className) }, { children: [_jsx("div", Object.assign({ className: 'tab_header' }, { children: _jsx(SlideSearchShareStatusTabHeader, { currentTab: currentTab, onClick: onClickTab, tabs: tabs }) })), _jsx("div", Object.assign({ className: 'tab_content' }, { children: _jsx(SlideSearchShareStatusTabContent, { currentTab: currentTab, isReceiveFolderOnePage: isReceiveFolderOnePage, isShareHistoryOnePage: isShareHistoryOnePage, onClickItem: onClickItem, paramId: paramId, receiveItems: receive.list, shareItems: share.list, skeletons: skeletons }) }))] })));
};
SlideSearchShareStatusTab.propTypes = {
    className: propStr(),
    initialCurrentTab: propOneOf(['receive', 'share']),
    onClickItem: propFunc(),
    receive: propShape().isRequired,
    share: propShape().isRequired,
    skeletons: propNumber(),
};
SlideSearchShareStatusTab.defaultProps = {
    className: '',
    initialCurrentTab: 'receive',
    onClickItem: undefined,
    skeletons: 6,
};
export default SlideSearchShareStatusTab;
